import { Box, Skeleton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const SellerIntegrationSettingsFormSkeleton = ({
  title,
}: {
  title: string;
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Typography component="h3" typography="openSans.h3" marginBottom="30px">
        {title}
      </Typography>
      <Typography
        sx={{
          maxWidth: '750px',
          marginBottom: '30px',
        }}
      >
        {t(
          // eslint-disable-next-line max-len
          'These settings control various aspects of the integration between RE-OPS and your Seller API.',
        )}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', maxWidth: '750px' }}>
        <Skeleton variant="rectangular" height="56px" sx={{ mb: '30px' }} />
      </Box>
    </>
  );
};

export { SellerIntegrationSettingsFormSkeleton };
